import { Button, IconButton, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SendIcon from '@mui/icons-material/Send';
import { useState } from "react";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const Chat = () => {
    const navigate = useNavigate();
    const [activeChat, setActiveChat] = useState<number | null>(1);
    const [rtActive, setRtActive] = useState(false);
    const chatList = [
        {
            id: 0,
            name: "Jashu Real Estate",
            msg: "3bhk fully luxury first floor only family",
        },
        {
            id: 1,
            name: "Ahmed Ai-Mansouri",
            msg: "Looking for 2bhk apartment",
        },
    ];
    const handleChatClick = (id: number) => {
        setActiveChat(id);
        setRtActive(true);
    };

    const handleChatListing = () => {

        setRtActive(false);
    };

    return (
        <>
            <div className="main_title">
                <h1>Messages</h1>
                <p>
                    Communicate With Your Customers
                </p>
            </div>
            <div className="chat_sc wrp_spc">


                <div className="inner">
                    <div className="lt">
                        <div className="form_input">
                            <div className="input_group">
                                <TextField
                                    autoComplete="off"
                                    hiddenLabel
                                    placeholder="Search"
                                    className="form_control"
                                    fullWidth
                                    variant="outlined"
                                />
                                <figure>
                                    <svg
                                        width="19"
                                        height="19"
                                        viewBox="0 0 19 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M7.99997 0.5C9.39795 0.499944 10.7681 0.890614 11.9559 1.62792C13.1436 2.36523 14.1016 3.41983 14.7218 4.6727C15.342 5.92558 15.5997 7.32686 15.4658 8.71841C15.3319 10.11 14.8117 11.4364 13.964 12.548L18.707 17.293C18.8863 17.473 18.9904 17.7144 18.9982 17.9684C19.006 18.2223 18.9168 18.4697 18.7487 18.6603C18.5807 18.8508 18.3464 18.9703 18.0935 18.9944C17.8406 19.0185 17.588 18.9454 17.387 18.79L17.293 18.707L12.548 13.964C11.601 14.6861 10.4956 15.1723 9.32341 15.3824C8.15119 15.5925 6.9458 15.5204 5.80697 15.1721C4.66814 14.8238 3.62862 14.2094 2.77443 13.3795C1.92023 12.5497 1.27592 11.5285 0.894799 10.4002C0.513683 9.27192 0.406722 8.06912 0.582766 6.89131C0.75881 5.7135 1.2128 4.59454 1.90717 3.62703C2.60153 2.65951 3.51631 1.87126 4.57581 1.32749C5.63532 0.783715 6.80908 0.500063 7.99997 0.5ZM7.99997 2.5C6.54128 2.5 5.14233 3.07946 4.11088 4.11091C3.07943 5.14236 2.49997 6.54131 2.49997 8C2.49997 9.45869 3.07943 10.8576 4.11088 11.8891C5.14233 12.9205 6.54128 13.5 7.99997 13.5C9.45866 13.5 10.8576 12.9205 11.8891 11.8891C12.9205 10.8576 13.5 9.45869 13.5 8C13.5 6.54131 12.9205 5.14236 11.8891 4.11091C10.8576 3.07946 9.45866 2.5 7.99997 2.5Z"
                                            fill="#696969"
                                        />
                                    </svg>
                                </figure>
                            </div>
                        </div>
                        {chatList.map((chat) => (
                            <div
                                key={chat.id}
                                className={`chat_single ${activeChat === chat.id ? "active" : ""}`}
                                onClick={() => {
                                    if (window.innerWidth < 911) {
                                        handleChatClick(chat.id);
                                    }
                                }}                            >
                                <span className="time">05:19 PM</span>
                                <figure>
                                    <img src="static/images/user_placeholder.png" alt="icon" />
                                </figure>
                                <p>
                                    <strong>{chat.name}</strong>
                                    <span className="unread">{chat.msg}</span>
                                    <caption>1</caption>
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className={`rt ${rtActive ? "active" : ""}`}>
                        <div className="chat_box">
                            <div className="chat_head">
                                <IconButton onClick={() => handleChatListing()}> <ArrowBackIosNewIcon /> </IconButton>
                                <figure>
                                    <img src="static/images/user_placeholder.png" alt="icon" />
                                </figure>
                                <p>Ahmed Ai-Mansouri <span> Online</span></p>
                            </div>
                            <div className="chat_body">
                                <p>Today at 5:03 PM</p>
                                <div className="single_message sended">
                                    <figure>
                                        <img src="static/images/user_placeholder.png" alt="icon" />
                                    </figure>
                                    <div className="msg_body">
                                        <p>
                                            Hi, Im looking to request a quote for some products. Can
                                            you assist me with that?
                                        </p>
                                    </div>
                                </div>
                                <div className="single_message recieved">
                                    <figure>
                                        <img src="static/images/user_placeholder.png" alt="icon" />
                                    </figure>
                                    <div className="msg_body">
                                        <p>
                                            Of course! I d be happy to assist you. What products are
                                            you interested in?
                                        </p>
                                    </div>
                                </div>
                                <div className="single_message sended">
                                    <figure>
                                        <img src="static/images/user_placeholder.png" alt="icon" />
                                    </figure>
                                    <div className="msg_body">
                                        <p>
                                            I'm interested in purchasing some apples for our store. We
                                            need a variety of types. Can you provide a quote for the
                                            following? <br />• 500 lbs of Gala apples <br />• 300 lbs
                                            of Fuji apples <br />• 200 lbs of Granny Smith apples
                                            Additionally, please include pricing for bulk orders.
                                        </p>
                                    </div>
                                </div>

                                <p>Today at 5:03 PM</p>
                                <div className="single_message recieved">
                                    <figure>
                                        <img src="static/images/user_placeholder.png" alt="icon" />
                                    </figure>
                                    <div className="msg_body">
                                        <p>
                                            Sorry , I m stuck in traffic. Please give me a moment.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="chat_foot">
                                {/* <figure>
                                    <svg
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M20.5176 10.0934H11.9066V1.48236C11.9066 0.981658 11.5007 0.575781 11 0.575781C10.4993 0.575781 10.0934 0.981658 10.0934 1.48236V10.0934H1.48236C0.981658 10.0934 0.575781 10.4993 0.575781 11C0.575781 11.5007 0.981658 11.9066 1.48236 11.9066H10.0934V20.5176C10.0934 21.0183 10.4993 21.4242 11 21.4242C11.5007 21.4242 11.9066 21.0183 11.9066 20.5176V11.9066H20.5176C21.0183 11.9066 21.4242 11.5007 21.4242 11C21.4242 10.4993 21.0183 10.0934 20.5176 10.0934Z"
                                            fill="white"
                                            stroke="white"
                                            strokeWidth="0.2"
                                        />
                                    </svg>
                                </figure> */}
                                <div className="form_input">
                                    <div className="input_group">
                                        <TextField
                                            hiddenLabel
                                            placeholder="Type a message..."
                                            fullWidth
                                        />
                                    </div>
                                </div>
                                <figure className="send">
                                    <SendIcon />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </>
    );
}
export default Chat;